import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import { useFetchBusinessUnits } from 'asset-actions-lib-forms/manageAccess/useFetchBusinessUnits';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BusinessUnitTagContainer({
  buId
}) {
  const {
    loading,
    data: buOptions
  } = useFetchBusinessUnits();
  if (loading || !buOptions) {
    return null;
  }
  return /*#__PURE__*/_jsx(BusinessUnitTag, {
    buOptions: buOptions,
    buId: buId
  });
}